function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="20" height="20" viewBox="0 0 20 22" {...props}><path d="M10.25 10.259h-.5v9.648l-3.766-3.04 4.23 3.81 3.519-4.142-3.483 3.433v-9.709zm8.503-8.777l-17.735.25.229 18.25 2.412-.5H1.477v-17.5h17.046v17.5l-2.185.499 2.644-.249-.229-18.25z" fillRule="nonzero" stroke="#3669C9" /></svg>;
});